import React from 'react';
import { Award, ExternalLink } from 'lucide-react';

const Certifications = () => {
  // EASY UPDATE: Add or modify certifications here
  // To update certification images, replace the 'image' URL with your own
  const certifications = [
    {
      name: 'INF.02',
      issuer: 'OKE',
      date: 'Aug 2025',
      image: 'https://placehold.co/340x340/1e293b/BCA4E3?text=INF.02',
      link: null, // Since the user just had text without a link
    },
    {
      name: 'Cambridge English: Advanced (CAE)',
      issuer: 'Cambridge English',
      date: 'Apr 2025',
      image: 'https://placehold.co/340x340/1e293b/BCA4E3?text=CAE',
      link: null,
    },
    {
      name: 'CCNA: Switching, Routing, and Wireless Essentials',
      issuer: 'Cisco Networking Academy',
      date: 'May 2023',
      image: 'https://images.credly.com/size/340x340/images/f4ccdba9-dd65-4349-baad-8f05df116443/CCNASRWE__1_.png',
      link: null, // Keep the link if they already had it
    },
    {
      name: 'CCNA: Introduction to Networks',
      issuer: 'Cisco Networking Academy',
      date: 'Apr 2023',
      image: 'https://images.credly.com/size/340x340/images/70d71df5-f3dc-4380-9b9d-f22513a70417/CCNAITN__1_.png', // Generic credly ccna1 image, or placeholder
      link: null,
    },
  ];

  return (
    <section id="certifications" className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-900">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">Certifications</h2>
          <div className="w-20 h-1 bg-[#BCA4E3] mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {certifications.map((cert, index) => {
            const Wrapper = cert.link ? 'a' : 'div';
            return (
              <Wrapper
                key={index}
                href={cert.link}
                target={cert.link ? "_blank" : undefined}
                rel={cert.link ? "noopener noreferrer" : undefined}
                className={`bg-slate-800 border border-slate-700 p-8 rounded-lg hover:shadow-lg hover:shadow-[#BCA4E3]/10 hover:border-[#BCA4E3]/30 transition-all duration-300 group flex flex-col h-full ${cert.link ? 'cursor-pointer' : ''}`}
              >
                <div className="flex flex-col items-center h-full">
                  <div className="w-40 h-40 mb-6 flex-shrink-0 flex items-center justify-center">
                    <img
                      src={cert.image}
                      alt={cert.name}
                      loading="lazy"
                      decoding="async"
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <h3 className="text-lg font-semibold text-white mb-2 text-center group-hover:text-[#BCA4E3] transition-colors flex-grow">
                    {cert.name}
                  </h3>
                  <div className="w-full flex flex-col items-center mt-auto">
                    <p className="text-slate-400 mb-1 text-center font-medium">{cert.issuer}</p>
                    <p className="text-sm text-slate-500 mb-0">{cert.date}</p>
                    {cert.link && (
                      <div className="flex items-center text-sm text-slate-400 group-hover:text-[#BCA4E3] transition-colors mt-2">
                        <span>View Credential</span>
                        <ExternalLink className="ml-2 w-4 h-4" />
                      </div>
                    )}
                  </div>
                </div>
              </Wrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Certifications;

